import { CSSResultGroup } from 'lit';
import { customElement } from 'lit/decorators.js';
import componentStyles from './outline-container-baseline.css.lit';
import { OutlineGridBaseline } from '../outline-grid-baseline/outline-grid-baseline';

/**
 * The Baseline Container component
 * @slot - The default, and only slot for this element.
 */
@customElement('outline-container-baseline')
export class OutlineContainerBaseline extends OutlineGridBaseline {
  static styles: CSSResultGroup = [OutlineGridBaseline.styles, componentStyles];
}

declare global {
  interface HTMLElementTagNameMap {
    'outline-container-baseline': OutlineContainerBaseline;
  }
}
